export const ICON_BLOCK_WIDTH = 31;
export const CHARACTER_WIDTH = 7;
export const EDGE_WIDTH = 100;
export const STEP_EDGE_WIDTH = 130;
export const DEFAULT_SCHEMA_HEIGHT = 80;
export const ADDITIONAL_SCHEMA_HEIGHT = 45;
export const CHILDREN_NODES_MARGIN = 10;

export const ALT_PADDING_WIDTH = 12;
export const ALT_EDGE_WIDTH_MIN = 80;
export const ALT_EDGE_WIDTH_MAX = 150;
export const ALT_MAX_EDGE_WIDTH_SUM = ALT_EDGE_WIDTH_MAX * 3;
